export default {
  MODAL_MEDIUM_WIDTH: 568, // in px
  MODAL_LARGE_WIDTH: 800, // in px
  MODAL_MEDIUM_HEIGHT: 600, // in px
  MODAL_LARGE_HEIGHT: 720, // in px
  CONTROL_PANEL_HEIGHT: 48, // in px
  LARGE_RES_WIDTH: 1400, // in px
  LARGE_RES_HEIGHT: 800, // in px
};
